import { signal } from "@preact/signals-react";
import { z } from "zod";

const LauncherLinkSchema = z.object({
  label: z.string(),
  href: z.string(),
});

const LinksSchema = z.object({
  windows: z.array(LauncherLinkSchema),
  macos: z.array(LauncherLinkSchema),
  linux: z.array(LauncherLinkSchema),
  android: z.array(LauncherLinkSchema),
});

class PreactStorage {
  #launcherLinks = signal(null);

  get launcherLinks() {
    return this.#launcherLinks.value;
  }

  async init() {
    try {
      const data = await fetch("/launcher.json");
      this.#launcherLinks.value = LinksSchema.parse(await data.json());
    } catch (error) {
      console.error("Failed to fetch launcher links:", error);
    }
  }
}

export const preactStorage = new PreactStorage();
